<template>
  <div
    style="
      text-align: center;
      color: #ffffff;
      height: 122px;
      width: 100%;
      font-size: 14px;
      background-color: #39393a;
      padding-top: 25px;
    "
  >
    <div>
      <span>{{span1_mark}}: {{span1_detail}}</span>
      <span>|</span>
      <span>{{span3_mark}}: {{span3_detail}}</span>
    </div>
    <div>
      <span>{{span0_mark}}: {{ span0_detail}}</span>
      <span>|</span>
      <span>
        {{span2_mark}}:
        <span style="color: #ffffff">{{span2_detail}}</span>
      </span>
    </div>
    <div>
      <span>
        {{span4_mark}}:
        <span style="color: #ffffff">
          <a href="https://beian.miit.gov.cn">{{span4_detail}}</a>
        </span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data () {
    return {
      span0_mark: '',
      span0_detail: '',
      span1_mark: '',
      span1_detail: '',
      span2_mark: '',
      span2_detail: '',
      span3_mark: '',
      span3_detail: '',
      span4_mark: '',
      span4_detail: ''
    };
  },
  created () {
    this.$axios.get('/index').then((res) => {
      this.span0_mark = res.data.data.web[0].mark
      this.span0_detail = res.data.data.web[0].detail
      this.span1_mark = res.data.data.web[1].mark
      this.span1_detail = res.data.data.web[1].detail
      this.span2_mark = res.data.data.web[2].mark
      this.span2_detail = res.data.data.web[2].detail
      this.span3_mark = res.data.data.web[3].mark
      this.span3_detail = res.data.data.web[3].detail
      this.span4_mark = res.data.data.web[4].mark
      this.span4_detail = res.data.data.web[4].detail
    })
  },
};
</script>
<style scoped>
span {
  margin: 0px 5px;
}
div > div {
  padding: 4px 5px;
}
</style>


